import React, {useState} from 'react';
import HeaderActions from '../../../common/DasnboardHeader/HeaderActions';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import UserLists from './UserLists';
import InviteUsers from './InviteUsers';
import DeleteDialog from '../../../common/DeteleDialog/DeleteDialog';
import DashboardHeader from '../../../common/DasnboardHeader/DashboardHeader';
import PeopleIcon from '@mui/icons-material/People';
import {styleBg} from '../../../common/Models/Validations';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}

          {...other}
      >
        {value === index && (
            <Box sx={{ pt: 3 }}>
              <Typography>{children}</Typography>
            </Box>
        )}
      </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function UserManagement() {
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [userId, setUserId] = useState(null);
  const [show, setShow] = useState(false);
  const [users, setUsers] = useState([]);
  const [meta, setMeta] = useState({total: 0});

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpen = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
    setUserId(null);
  };

  const handleShowOpen = () => {
    setShow(true);
  }

  const handleExit = () => {
    setShow(false);
    setUserId(null);
  }

  const handleDescription = () => {
    if(value === 0) {
      return "Total Museum Assistant"
    } else if (value === 1) {
      return "Total Receptionists"
    } else if (value === 2) {
      return "Total Conservators"
    } else if (value === 3) {
      return "Total Interns"
    } else {
      return "Total Volunteers"
    }
  }

  return (
        <PageWrapper>
      <div>
        {/* <HeaderActions title={'User Management'} handleOpen={handleOpen} btnName={'+ Invite Staff'}/> */}
        <Box sx={{mb:2}}>
          <DashboardHeader title={'User Management'} total={meta?.total} IconName={PeopleIcon} iconColor={'#ff9653'} desc={handleDescription()} handleOpen={handleOpen} btnName={'+ Invite Staff'}/>
        </Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '98%'}}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="MUSEUM ASSISTANTS" {...a11yProps(0)}  sx={{width: 250, ...styleBg(0, value)}}/>
            <Tab label="RECEPTIONISTS" {...a11yProps(1)}  sx={{width: 250, ...styleBg(1, value)}}/>
            <Tab label="CONSERVATORS" {...a11yProps(2)}  sx={{width: 250, ...styleBg(2, value)}}/>
            <Tab label="INTERNS" {...a11yProps(3)} sx={{width: 250, ...styleBg(3, value)}}/>
            <Tab label="VOLUNTEERS" {...a11yProps(4)}  sx={{width: 250, ...styleBg(4, value)}}/>
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <UserLists roleIds={3} setUserId={setUserId} handleOpen={handleOpen} handleShowOpen={handleShowOpen}
                     users={users} setUsers={setUsers} meta={meta} setMeta={setMeta}/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <UserLists roleIds={4} setUserId={setUserId} handleOpen={handleOpen} handleShowOpen={handleShowOpen}
                     users={users} setUsers={setUsers} meta={meta} setMeta={setMeta}/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <UserLists roleIds={7} setUserId={setUserId} handleOpen={handleOpen} handleShowOpen={handleShowOpen}
                     users={users} setUsers={setUsers} meta={meta} setMeta={setMeta}/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <UserLists roleIds={5} setUserId={setUserId} handleOpen={handleOpen} handleShowOpen={handleShowOpen}
                     users={users} setUsers={setUsers} meta={meta} setMeta={setMeta}/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          <UserLists roleIds={6} setUserId={setUserId} handleOpen={handleOpen} handleShowOpen={handleShowOpen}
                     users={users} setUsers={setUsers} meta={meta} setMeta={setMeta}/>
        </CustomTabPanel>
        {open &&
            <InviteUsers open={open} handleAction={handleClose} userId={userId} editProfile={false}/>}
        {show &&
            <DeleteDialog open={show} handleAction={handleExit} userId={userId} users={users} setUsers={setUsers}/>}
      </div>
      </PageWrapper>
  );
}